import { Component, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Card } from '@directives/card';
import { Button } from '@shared/button/button';
import type { DialogWrapperDataInput } from '@appTypes';
import { FeatureFlags } from '@services/core/feature-flags';

@Component({
  selector: 'app-dialog-wrapper',
  imports: [ NgComponentOutlet, Card, Button ],
  templateUrl: './dialog-wrapper.html',
  styleUrls: [ './dialog-wrapper.scss' ],
})
export class DialogWrapper {
  // Dependencias
  protected readonly dialogRef = inject(DialogRef);
  protected readonly inputData = inject<DialogWrapperDataInput>(DIALOG_DATA);
  private readonly featureFlagsService = inject(FeatureFlags);

  // Signals / atributos
  useClassicComponents = !this.featureFlagsService.isActive('BKUIComponents');
}
